import { usePlayerContext } from "common/contexts/playerContext"
import { chunk, reduce } from "lodash"
import React, { memo, useMemo } from "react"
import { timeStrToSeconds } from "utils/dates"
import { TranscriptionSkeleton } from "../skeletons/transcriptionSkeleton"
import { TranscriptionLine } from "./trancriptionLine"

const mapTranscription = ({ lines, interval, transcriptLineCallback }) => {
  // Check if format is correct
  if(lines.length <= 1 || (lines.length - 1) % 4 !== 0 || lines[0] !== "WEBVTT") return 

  // Remove the first line: VTT files contains WEBVTT word as the first line
  const transcriptionChunkArray = chunk(lines.slice(1), 4);
  const result = reduce(transcriptionChunkArray, (accumulator, transcription) => {
    const timeSplitted = transcription[2]?.split(" ");
    const startTime = timeSplitted?.[0];
    const endTime = timeSplitted?.[2];
    const text = transcription[3];

    // If inside current interval, update it
    if (timeStrToSeconds(endTime) < interval * accumulator.length + 1 && accumulator.length) {
      const currentInterval = accumulator[accumulator.length-1]
      accumulator[accumulator.length-1] = {
        ...currentInterval,
        endTime,
        text: currentInterval.text + text
      };
    }
    else {
      const newInterval = {
        id: `transcription-line-${accumulator.length + 1}`,
        startTime: startTime,
        endTime: endTime,
        text: text
      }
      // Avoid processing empty intervals
      if(newInterval.text) accumulator.push(transcriptLineCallback(newInterval));
    }
    return accumulator
  }, [])

  return result
}

const _Transcription = ({ transcriptionStr, loading }) => {
  const playerRef = usePlayerContext()

  const transcriptionComponent = useMemo(() => {
    const lines = transcriptionStr?.split("\n") ?? []
    return mapTranscription({ 
      lines, 
      interval: 3, 
      transcriptLineCallback: ({id, startTime, endTime, text}) => 
        (<TranscriptionLine 
          key={id}
          endTime={endTime}
          text={text} 
          onClick={() => playerRef.current?.seekTo(timeStrToSeconds(startTime), "seconds")}
        />)
    })
  }, [transcriptionStr, playerRef.current])

  if (loading) return <TranscriptionSkeleton/>
  return (
    <>{transcriptionComponent ?? <p>Cannot load transcription</p>}</>
  )
}

export const Transcription = memo(_Transcription)